import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import {withLocator} from '../../../../contexts/locator'
import type {State} from '../../../../reducers/types'
import {getBuildsData, getBuildsLocatorWithPage, getBuildsReady} from '../../../../selectors'
import {getPager} from '../../../common/Pager/Pager.selectors'
import {PagerGroup} from '../../../common/Pager/Pager.types'

import BuildTypeOverviewFooter from './BuildTypeOverviewFooter'
import type {ReduxOwnProps, StateProps} from './BuildTypeOverviewFooter.types'

const mapStateToProps = (state: State, {locator, page = 1}: ReduxOwnProps): StateProps => {
  const locatorWithPage = locator && getBuildsLocatorWithPage(state, locator, page)
  return {
    buildsReady: getBuildsReady(state, locatorWithPage),
    buildCount: getBuildsData(state, locatorWithPage).data.length,
    lookupLimitWarning: getPager(state, PagerGroup.BUILD).lookupLimitWarning ?? false,
  }
}

export default compose(withLocator, connect(mapStateToProps, {}))(BuildTypeOverviewFooter)
